import { render } from "./AnonymousWrapper.vue?vue&type=template&id=1b7f56b8"
import script from "./AnonymousWrapper.vue?vue&type=script&lang=js"
export * from "./AnonymousWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__